import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import { Link } from "react-router-dom";
import {
  FaMicrophoneAlt,
  FaTshirt,
  FaShieldAlt,
  FaExclamationCircle,
} from "react-icons/fa";
import { PiDetective } from "react-icons/pi";
import { BsRobot } from "react-icons/bs";
import { MdDevices } from "react-icons/md";
import { FaLock } from "react-icons/fa6";
import bgauth from "../Images/bg-auth.jpg";
import registeredfacilitiesbannerhome from "../Images/cropped-clipart.png";
import bookings from "../Images/bookings.png";
import nearbyfacilty from "../Images/nearbyfacilty.avif";
import excercisesbanner from "../Images/excercisebanner.png";
import onlinemeeting from "../Images/onlinemeeting.jpg";
import onlinereport from "../Images/onlinereport.jpg";
import data from "../Images/data.jpg";
import workflow from "../Images/workflow.jpg";
import arr_down from "../Images/arr_down.svg";

const MainPage = () => {
  return (
    <div>
      <Header />
      <section
        className="relative py-40 text-white"
        style={{
          backgroundImage: `url(${bgauth})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container mx-auto px-4 relative max-w-3xl">
          <div className=" backdrop-blur-md bg-black-50/50 rounded-md p-8 shadow-lg">
            <div className="text-center mb-12">
              <h1 className="text-4xl font-sans font-semibold">
                Empowering Your Vision with Innovation
              </h1>
              <h2 className="mt-4 text-lg italic font-light">
                "Transforming ideas into reality with cutting-edge technology
                and unwavering commitment to excellence"
              </h2>
              <Link to="/signin">
                <button className="mt-8 bg-slate-500 text-white px-6 py-3 rounded-md shadow-md hover:text-black hover:bg-transparent hover:border-slate-500 border-2 border-solid transition-all duration-300">
                  Get Started Now
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-12 bg-gray-100" data-aos="fade-up">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-semibold mb-8 text-center">
            Our Advanced Capabilities
          </h2>
          <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <PiDetective size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">
                Real-Time Monitoring
              </span>
            </div>
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <BsRobot size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">AI-Powered Analysis</span>
            </div>
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <FaMicrophoneAlt size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">Voice Analysis</span>
            </div>
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <MdDevices size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">
                Multi-Device Detection
              </span>
            </div>
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <FaShieldAlt size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">
                Secure Administration
              </span>
            </div>
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <FaExclamationCircle size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">
                Suspicious Activity Alerts
              </span>
            </div>
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <FaLock size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">Data Encryption</span>
            </div>
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <FaTshirt size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">
                Role Based Privileges
              </span>
            </div>
          </div>
        </div>
      </section>

      <section className="home bg-white mt-6" data-aos="fade-up">
        <div className="py-8 px-4 mx-auto max-w-screen-xl container sm:py-8 lg:px-6 flex flex-col lg:flex-row items-center space-y-8">
          <div className="home-content lg:w-3/4 lg:p-20 lg:pl-0">
            <div className="title">
              <h2 className="text-xl lg:text-3xl font-semibold text-[#64748B]">
                Seamless Meetings with Live Transcription and Device Detection
              </h2>
            </div>
            <div className="description mt-4 lg:mt-6">
              <p className="text-gray-600 font-semibold">
                Our platform ensures smooth and secure virtual interviews with
                real-time live transcription powered by AI. Detecting external
                devices during meetings adds an extra layer of integrity,
                preventing unauthorized assistance. With advanced monitoring,
                you can confidently conduct interviews without any disruptions
                or compromises.
              </p>
            </div>
            <Link to="/signin">
              <button className="mt-8 bg-slate-500 text-white px-5 py-2 rounded-md shadow-md hover:text-black hover:bg-transparent hover:border-slate-500 border-2 border-solid transition-all duration-300">
                Explore Now
                <i className="fas fa-arrow-right ml-2"></i>
              </button>
            </Link>
          </div>
          <div className="w-full md:w-6/12 h-auto">
            <img
              src={onlinemeeting}
              alt="image1"
              className="w-full h-auto rounded-lg "
            />
          </div>
        </div>
      </section>

      <section className="home bg-gray-100 mt-6 py-16" data-aos="fade-up">
        <div className="py-8 px-4 mx-auto max-w-screen-xl container sm:py-12 lg:px-12 flex flex-col lg:flex-row items-center space-y-8">
          <div className="w-full md:w-6/12 h-auto">
            <img
              src={onlinereport}
              alt="image1"
              className="w-full h-auto rounded-lg"
            />
          </div>
          <div className="home-content lg:w-3/4 lg:p-0 lg:pl-20 ">
            <div className="title">
              <h2 className="text-xl lg:text-3xl font-semibold text-[#64748B]">
                Comprehensive Reports and AI-Powered Insights
              </h2>
            </div>
            <div className="description mt-4 lg:mt-6">
              <p className="text-gray-600 font-semibold">
                Gain access to detailed reports and AI-driven summaries that
                provide a deep analysis of candidate responses. The recruiter
                dashboard centralizes reports, historical data, and insights,
                enabling informed decisions. From detecting inconsistencies to
                tracking progress over time, our system offers everything you
                need for effective candidate evaluation and hiring transparency.
              </p>
            </div>
            <Link to="/signin">
              <button className="mt-8 bg-slate-500 text-white px-5 py-2 rounded-md shadow-md hover:text-black hover:bg-transparent hover:border-slate-500 border-2 border-solid transition-all duration-300">
                Explore Now
                <i className="fas fa-arrow-right ml-2"></i>
              </button>
            </Link>
          </div>
        </div>
      </section>

      <section className="home bg-white mt-6" data-aos="fade-up">
        <div className="py-8 px-4 mx-auto max-w-screen-xl container sm:py-8 lg:px-6 flex flex-col lg:flex-row items-center space-y-8">
          <div className="home-content lg:w-3/4 lg:p-20 lg:pl-0">
            <div className="title">
              <h2 className="text-xl lg:text-3xl font-semibold text-[#64748B]">
                Enhanced Security with AI-Driven Detection
              </h2>
            </div>
            <div className="description mt-4 lg:mt-6">
              <p className="text-gray-600 font-semibold">
                Our platform employs cutting-edge AI algorithms to identify
                unusual activities during interviews, such as background noise,
                multiple voices, or suspicious screen usage. This ensures the
                highest level of security, giving recruiters confidence in the
                authenticity of the process while maintaining a seamless
                experience for candidates.
              </p>
            </div>
            <Link to="/signin">
              <button className="mt-8 bg-slate-500 text-white px-5 py-2 rounded-md shadow-md hover:text-black hover:bg-transparent hover:border-slate-500 border-2 border-solid transition-all duration-300">
                Explore Now
                <i className="fas fa-arrow-right ml-2"></i>
              </button>
            </Link>
          </div>
          <div className="w-full md:w-6/12 h-auto">
            <img src={data} alt="image1" className="w-full h-auto rounded-lg" />
          </div>
        </div>
      </section>

      <section className="home bg-gray-100 mt-6 py-16" data-aos="fade-up">
        <div className="py-8 px-4 mx-auto max-w-screen-xl container sm:py-8 lg:px-6 flex flex-col lg:flex-row items-center space-y-8">
          <div className="w-full md:w-6/12 h-auto">
            <img
              src={workflow}
              alt="image1"
              className="w-full h-auto rounded-lg"
            />
          </div>
          <div className="home-content lg:w-3/4 lg:p-0 lg:pl-20 ">
            <div className="title">
              <h2 className="text-xl lg:text-3xl font-semibold text-[#64748B]">
                Streamlined Workflow for Recruiters
              </h2>
            </div>
            <div className="description mt-4 lg:mt-6">
              <p className="text-gray-600 font-semibold">
                With an intuitive recruiter dashboard, managing interviews has
                never been easier. From scheduling interviews to accessing live
                insights and post-interview reports, the platform simplifies
                every step. The consolidated view of data, coupled with
                real-time notifications, empowers recruiters to focus on what
                matters most—hiring the best talent.
              </p>
            </div>
            <Link to="/signin">
              <button className="mt-8 bg-slate-500 text-white px-5 py-2 rounded-md shadow-md hover:text-black hover:bg-transparent hover:border-slate-500 border-2 border-solid transition-all duration-300">
                Explore Now
                <i className="fas fa-arrow-right ml-2"></i>
              </button>
            </Link>
          </div>
        </div>
      </section>
      <div
        className=" rounded-5xl rounded-tl-none m-10 p-10 flex flex-col items-center text-center max-w-[80vw] mx-auto"
        data-aos="fade-up"
      >
        <div className="flex flex-col md:flex-row my-10 space-y-4 md:space-y-0">
          <div className="w-full md:w-1/2 pr-2">
            <p className="font-semibold  text-2xl md:text-xl lg:text-2xl text-left">
              Never Miss Out on amazing candidate with our tools! Detection at
              interviews at its finest.
            </p>
          </div>
          <div className="w-full md:w-1/4 border-t md:border-t-0 md:border-l border-black pt-4 md:pt-0">
            <h1 className="font-semibold text-4xl md:text-3xl lg:text-5xl">
              40+
            </h1>
            <h4 className="text-sm">Helpfull Tools</h4>
          </div>
          <div className="w-full md:w-1/4 border-t md:border-t-0 md:border-l border-black pt-4 md:pt-0">
            <h1 className="font-semibold text-4xl md:text-3xl lg:text-5xl">
              50,000
            </h1>
            <h4 className="text-sm">Total Recrutors</h4>
          </div>
        </div>

        <div className="overflow-hidden w-full">
          <div className="flex space-x-28 animate-marquee justify-center">
            <div className="flex items-center rounded-lg p-4 my-2 min-w-max">
              <img src={bookings} alt="title" className="w-16 h-16 mr-4" />
              <div className="flex flex-col items-start">
                <h1 className="font-medium text-lg">Company one</h1>
                <p className="text-sm text-gray-600">Sample text</p>
              </div>
            </div>
            <div className="flex items-center rounded-lg p-4 my-2 min-w-max">
              <img
                src={excercisesbanner}
                alt="title"
                className="w-16 h-16 mr-4 rounded-2xl bg-white"
              />
              <div className="flex flex-col items-start">
                <h1 className="font-medium text-lg">Company two</h1>
                <p className="text-sm text-gray-600">Sample text</p>
              </div>
            </div>
            <div className="flex items-center rounded-lg p-4 my-2 min-w-max">
              <img
                src={registeredfacilitiesbannerhome}
                alt="title"
                className="w-16 h-16 mr-4 rounded-2xl bg-white"
              />
              <div className="flex flex-col items-start">
                <h1 className="font-medium text-lg">Company three</h1>
                <p className="text-sm text-gray-600">Sample text</p>
              </div>
            </div>
            <div className="flex items-center rounded-lg p-4 my-2 min-w-max">
              <img
                src={nearbyfacilty}
                alt="title"
                className="w-16 h-16 mr-4 rounded-2xl bg-white"
              />
              <div className="flex flex-col items-start">
                <h1 className="font-medium text-lg">Company four</h1>
                <p className="text-sm text-gray-600">Sample text</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-transparent mt-12 flex flex-col items-center text-center w-full mx-auto">
        <h1 className="text-2xl md:text-4xl tracking-tight m-0 font-semibold">
          Frequently Asked Questions
        </h1>
      </div>
      <section
        className="px-1 md:px-2 pb-8 pt-10 flex justify-between flex-col md:flex-row max-w-screen-2xl mx-auto"
        data-aos="fade-up"
      >
        <div className="w-full mt-1 md:mt-4">
          <details className="border border-[#F2F4F5] rounded-md py-8 px-3 relative open:shadow-lg mb-1 bg-gray-100 duration-300">
            <summary className="list-none font-semibold relative text-lg cursor-pointer pr-7 ">
              What services do you provide?
              <div className="absolute top-0 right-0 rounded-full px-1 py-0.5 cursor-pointer visible open:invisible">
                <div className="p-1 border border-black rounded-full ">
                  <img src={arr_down} alt="" className="h-4 w-4" />
                </div>
              </div>
            </summary>
            <p className="text-md pt-3">
              We specialize in web and app development, AI-driven solutions, and
              UI/UX design tailored to your unique needs.
            </p>
          </details>
          <details className="border border-slate-200 rounded-md py-8 px-3 relative open:shadow-lg mb-1 bg-gray-100 duration-300">
            <summary className="list-none font-semibold relative text-lg cursor-pointer pr-7">
              What industries do you serve?
              <div className="absolute top-0 right-0 rounded-full px-1 py-0.5 cursor-pointer visible open:invisible">
                <div className="p-1 border border-black rounded-full ">
                  <img src={arr_down} alt="" className="h-4 w-4" />
                </div>
              </div>
            </summary>
            <p className="text-md pt-3">
              Our solutions are versatile, serving industries like e-commerce,
              healthcare, education, and more.
            </p>
          </details>
          <details className="border border-slate-200 rounded-md py-8 px-3 relative open:shadow-lg mb-1 bg-gray-100 duration-300">
            <summary className="list-none font-semibold relative text-lg cursor-pointer pr-7">
              How do we ensure project success?
              <div className="absolute top-0 right-0 rounded-full px-1 py-0.5 cursor-pointer visible open:invisible">
                <div className="p-1 border border-black rounded-full ">
                  <img src={arr_down} alt="" className="h-4 w-4" />
                </div>
              </div>
            </summary>
            <p className="text-md pt-3">
              Through detailed planning, transparent communication, and
              milestone-based progress tracking, we ensure on-time and
              top-quality delivery.
            </p>
          </details>
          <details className="border border-slate-200 rounded-md py-8 px-3 relative open:shadow-lg mb-1 bg-gray-100 duration-300">
            <summary className="list-none font-semibold relative text-lg cursor-pointer pr-7">
              How can I get started with your services?
              <div className="absolute top-0 right-0 rounded-full px-1 py-0.5 cursor-pointer visible open:invisible">
                <div className="p-1 border border-black rounded-full ">
                  <img src={arr_down} alt="" className="h-4 w-4" />
                </div>
              </div>
            </summary>
            <p className="text-md pt-3">
              Simply reach out through our contact page, and our team will guide
              you through the onboarding process.
            </p>
          </details>
          <details className="border border-slate-200 rounded-md py-8 px-3 relative open:shadow-lg mb-1 bg-gray-100 duration-300">
            <summary className="list-none font-semibold relative text-lg cursor-pointer pr-7">
              When do I reset a password ?
              <div className="absolute top-0 right-0 rounded-full px-1 py-0.5 cursor-pointer visible open:invisible">
                <div className="p-1 border border-black rounded-full ">
                  <img src={arr_down} alt="" className="h-4 w-4" />
                </div>
              </div>
            </summary>
            <p className="text-md pt-3">
              Yes, in order to use My Page, you must allow the use of cookies in
              your browser.
              <br />
              <br />
              See also: What is a cookie and what does it do?
            </p>
          </details>
        </div>
      </section>
      {/* <div className="py-32 text-center">Conact us for any suport</div> */}
      <section className="bg-white mt-6">
        <div className="py-8 px-4 mx-auto max-w-screen-xl sm:py-20 lg:px-6">
          <div className="flex flex-col items-center space-y-8">
            <h1 className="text-[#64748B] text-[1.3rem] md:text-3xl lg:text-4xl font-bold">
              Your Feedback Matters
            </h1>
            <p className="text-black text-center text-xl font-medium max-w-[786px]">
              If you want to report against any organization related to booking
              or you want to give feedback related to our facilities
            </p>
            <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
              <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
                <Link to="/contact">
                  <button
                    type="button"
                    className="bg-slate-500 text-white px-5 py-3 rounded-md shadow-md hover:text-black hover:bg-transparent hover:border-slate-500 border-2 border-solid transition-all duration-300"
                  >
                    Click Here to Proceed
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default MainPage;
